import { resolveLevierColorTreatment } from '@/lib/display-tweaks';
import { ActivationBlock } from './activation-block';
import { PreviewFrame } from './preview-frame';
import type { SettingPreviewProps } from './setting-preview-props';

/**
 * `matrix-activation-levier-colors`: the activation block painted per levier.
 * It also reads the current `matrix-activation-levier-names`, because with the
 * names hidden `accent` and `tint` fall back to the side band, exactly as in the grid.
 */
export function ActivationColorsPreview({ value, tweaks }: SettingPreviewProps) {
  const names = tweaks['matrix-activation-levier-names'] ?? 'hidden';
  return (
    <PreviewFrame>
      <ActivationBlock names={names} treatment={resolveLevierColorTreatment(value, names)} />
    </PreviewFrame>
  );
}
